import { render, staticRenderFns } from "./HomePageV2.vue?vue&type=template&id=70d29472&scoped=true&lang=pug"
import script from "./HomePageV2.vue?vue&type=script&lang=js"
export * from "./HomePageV2.vue?vue&type=script&lang=js"
import style0 from "./HomePageV2.vue?vue&type=style&index=0&id=70d29472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d29472",
  null
  
)

export default component.exports